import ICON__circle_exclamation from '@/assets/icons/font_awesome/circle-exclamation-solid.svg?react';
import { assert_array_not_empty } from '@shared/asserts/utils_asserts';
import { ERROR_GRAPH__base } from '@shared/dto/generation/graph_invoke/_errors/ERROR_GRAPH__base';

interface PROPS {
  errors: ERROR_GRAPH__base[];
}

export function G_VIEW__graph_field_errors({ errors }: PROPS) {
  assert_array_not_empty(errors);

  const tooltip_text = errors.map(error => error.type).join('\n');

  return (
    <div className="absolute left-[-1.75rem]">
      <div className="relative group ">
        <ICON__circle_exclamation className="!size-3 text-red-600" />
        <div className="absolute left-0 top-6 invisible group-hover:visible bg-neutral-900 text-white text-xs p-2 rounded whitespace-pre-wrap z-[100] max-w-[20rem]">
          {tooltip_text}
        </div>
      </div>
    </div>
  );
}
